import React from "react";
import { Box, Grid2 as Grid, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

interface ViewSubCardProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  variant?: "primary" | "nested";
}

const ViewSubCard: React.FC<ViewSubCardProps> = ({
  title,
  subtitle,
  children,
  variant = "primary",
}) => {
  const isNested = variant === "nested";

  return (
    <Grid size={{ xs: 12 }}>
      <Box
        sx={{
          border: "1px solid",
          borderColor: (theme) =>
            isNested
              ? theme.palette.mode === "dark"
                ? theme.palette.grey[700]
                : theme.palette.grey[300]
              : theme.palette.primary.main,
          borderRadius: 1,
          p: 2,
          backgroundColor: (theme) =>
            isNested
              ? theme.palette.mode === "dark"
                ? alpha(theme.palette.grey[500], 0.12)
                : theme.palette.grey[100]
              : theme.palette.mode === "dark"
                ? alpha(theme.palette.grey[700], 0.35)
                : theme.palette.grey[300],
        }}
      >
        {title ? (
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 600,
              color: "primary.main",
              mb: 2,
            }}
          >
            {title}
          </Typography>
        ) : null}
        {subtitle ? (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", mb: 1.5 }}
          >
            {subtitle}
          </Typography>
        ) : null}
        <Grid container spacing={2}>
          {children}
        </Grid>
      </Box>
    </Grid>
  );
};

export default ViewSubCard;
